import Util from '@/helper/Utility.js';

export function ProvinceModel(dict) {
    this.provinceCode = dict.province_code
        ? dict.province_code
        : dict.ProvinceCode;

    this.provinceName = dict.province_name
        ? dict.province_name
        : dict.ProvinceName;

    this.provinceNameEN = dict.ProvinceName_EN;
}

export function DistrictModel(dict) {
    this.districtCode = dict.district_code
        ? dict.district_code
        : dict.DistrictCode;

    this.districtName = dict.district_name
        ? dict.district_name
        : dict.DistrictName;

    this.districtNameEN = dict.district_name_EN
        ? dict.district_name_EN
        : dict.DistrictName_EN;

    this.provinceCode = dict.province_code
        ? dict.province_code
        : dict.ProvinceCode;
}

export function SubDistrictModel(dict) {
    this.subdistrictCode = dict.subdistrict_code
        ? dict.subdistrict_code
        : dict.SubDistrictCode;

    this.subdistrictName = dict.subdistrict_name
        ? dict.subdistrict_name
        : dict.SubDistrictName;

    this.provinceCode = dict.provinceCode
        ? dict.provinceCode
        : dict.ProvinceCode;

    this.districtCode = dict.districtCode
        ? dict.districtCode
        : dict.DistrictCode;

    this.subdistrictNameEN = dict.SubDistrictName_EN;
    this.city = dict.city;
    this.zipcode = dict.zip_code;
}

export function AddressModel() {
    this.strAddress = '';
    this.strProvinceCode = '';
    this.strProvinceName = '';
    this.strProvinceNameEn = '';
    this.strDistrictCode = '';
    this.strDistrictName = '';
    this.strDistrictNameEn = '';
    this.strSubDistrictCode = '';
    this.strSubDistrictName = '';
    this.strSubDistrictNameEn = '';
    this.strZipcode = '';

    this.setAddressFromApi = function(data) {
        this.strAddress = data.Address;
        this.strProvinceCode = data.ProvinceCode;
        this.strProvinceName = data.ProvinceName;
        this.strProvinceNameEn = data.ProvinceNameEN;
        this.strDistrictCode = data.DistrictCode;
        this.strDistrictName = data.DistrictName;
        this.strDistrictNameEn = data.DistrictNameEN;
        this.strSubDistrictCode = data.SubDistrictCode;
        this.strSubDistrictName = data.SubDistrictName;
        this.strSubDistrictNameEn = data.SubDistrictNameEN;
        this.strZipcode = data.Zipcode;
    },

    this.getProvinceModel = function() {
        var province = new ProvinceModel({
            province_code: this.strProvinceCode,
            province_name: this.strProvinceName,
            ProvinceName_EN: this.strProvinceNameEn,
        });
        return province;
    };

    this.getDistrictModel = function () {
        var district = new DistrictModel({
            district_code: this.strDistrictCode,
            district_name: this.strDistrictName,
            district_name_EN: this.strDistrictNameEn,
            province_code: this.strProvinceCode,
        });
        return district;
    };

    this.getSubDistrictModel = function() {
        var subDistrict = new SubDistrictModel({
            subdistrict_code: this.strSubDistrictCode,
            subdistrict_name: this.strSubDistrictName,
            SubDistrictName_EN: this.strSubDistrictNameEn,
            districtCode: this.strDistrictNameEn,
            provinceCode: this.strProvinceName,
            zip_code: this.strZipcode,
        });
        return subDistrict;
    };

    this.getObject = function() {
        return {
            strAddress              :this.strAddress,
            strProvinceCode         :this.strProvinceCode,
            strProvinceName         :this.strProvinceName,
            strProvinceNameEn       :this.strProvinceNameEn,
            strDistrictCode         :this.strDistrictCode,
            strDistrictName         :this.strDistrictName,
            strDistrictNameEn       :this.strDistrictNameEn,
            strSubDistrictCode      :this.strSubDistrictCode,
            strSubDistrictName      :this.strSubDistrictName,
            strSubDistrictNameEn    :this.strSubDistrictNameEn,
            strZipcode              :this.strZipcode,
        };
    };
}

export function AddressListItemModel(address) {
    this.partitionKey = address.PartitionKey || '';
    this.rowKey = address.RowKey || '';
    this.active = address.Active;
    this.type = address.Type;
    this.isDefault = address.IsDefault;
    this.isDefaultTax = address.IsDefaultTax;
    this.createDate = address.CreateDate;
    this.modifyDate = address.ModifyDate;
    this.extra = address.Extra || '';
    this.timestamp = address.Timestamp || '';
    this.addressItem = new AddressItemModel(address);
    this.taxAddressItem = new TaxAddressItem(address);
}

export function AddressItemModel(address) {
    if (!address) address = {};

    this.partitionKey = address.PartitionKey || '';
    this.rowKey = address.RowKey || '';
    this.type = address.Type || '';
    this.isDefault = address.IsDefault;
    this.addressname = address.AddressName || '';
    this.title = address.Title || '';
    this.firstname = address.FirstName || '';
    this.lastname = address.LastName || '';
    this.name = address.Name || '';
    this.companyname = address.CompanyName || '';
    this.contact_number = address.ContactNumber || '';
    this.home_contact_number = address.HomeContactNumber || '';
    this.email = address.Email || '';
    this.address = address.Address || '';
    this.village = address.Village || '';
    this.building = address.Building || '';
    this.number = address.Number || '';
    this.moo = address.Moo || '';
    this.room = address.Room || '';
    this.floor = address.Floor || '';
    this.soi = address.Soi || '';
    this.road = address.Road || '';
    this.subdistrict_code = address.SubDistrictCode || '';
    this.subdistrict_name = address.SubDistrictName || '';
    this.district_code = address.DistrictCode || '';
    this.district_name = address.DistrictName || '';
    this.province_code = address.ProvinceCode || '';
    this.province_name = address.ProvinceName || '';
    this.countryId = address.CountryId || '';
    this.country_code = address.CountryCode || '';
    this.country_name = address.CountryName || '';
    this.zipcode = address.Zipcode || '';
    this.remark = address.Remark || '';
    this.landmark = address.Landmark || '';
    this.latitude = address.Latitude || '';
    this.longitude = address.Longitude || '';

    this.getParams = function () {
        var params = {
            key: this.rowKey,
            isdefault: this.isDefault,
            addressname: this.addressname,
            name: this.name,
            firstname: this.firstname,
            lastname: this.lastname,
            contact_number: this.contact_number,
            home_contact_number: this.home_contact_number,
            email: this.email,
            address: this.address,
            village: this.village,
            building: this.building,
            number: this.number,
            moo: this.moo,
            room: this.room,
            floor: this.floor,
            soi: this.soi,
            road: this.road,
            remark: this.remark,
            landmark: this.landmark,
            subdistrict_code: this.subdistrict_code,
            subdistrict_name: this.subdistrict_name,
            district_code: this.district_code,
            district_name: this.district_name,
            province_code: this.province_code,
            province_name: this.province_name,
            zipcode: this.zipcode,
            latitude: this.latitude,
            longtitude: this.longtitude,
            countryId: this.countryId,
        };

        return Util.cleanObjectEmptyStr(params);
    }
}

export function TaxAddressItem(address) {
    if (!address) address = {};

    this.partitionKey = address.PartitionKey || '';
    this.rowKey = address.RowKey || '';
    this.addressname = address.TaxAddressName || '';
    this.title = address.Title || '';
    this.firstname = address.FirstName || '';
    this.lastname = address.LastName || '';
    this.name = address.TaxName || '';
    this.taxid = address.TaxId || '';
    this.companyname = address.CompanyName || '';
    this.contact_number = address.ContactNumber || '';
    this.home_contact_number = address.HomeContactNumber || '';
    this.email = address.Email || '';
    this.number = address.TaxNumber || '';
    this.soi = address.TaxSoi || '';
    this.subdistrict_code = address.TaxSubDistrictCode || '';
    this.subdistrict_name = address.TaxSubDistrictName || '';
    this.district_code = address.TaxDistrictCode || '';
    this.district_name = address.TaxDistrictName || '';
    this.province_code = address.TaxProvinceCode || '';
    this.province_name = address.TaxProvinceName || '';
    this.countryId = address.CountryId || '';
    this.zipcode = address.TaxZipcode || '';

    this.getParams = function (branchId, branchName, persontype) {
        var params = {
            key: this.rowKey,
            isdefault: this.isDefault,
            branchId: branchId,
            branchName: branchName,
            persontype: persontype,
            addressname: this.addressname,
            name: this.taxname,
            firstname: this.taxfirstname,
            lastname: this.taxlastname,
            taxid: this.taxid,
            contact_number: this.contact_number,
            home_contact_number: this.home_contact_number,
            email: this.email,
            address: this.address,
            village: this.village,
            building: this.building,
            number: this.number,
            moo: this.moo,
            room: this.room,
            floor: this.floor,
            soi: this.soi,
            road: this.road,
            remark: this.remark,
            landmark: this.landmark,
            subdistrict_code: this.subdistrict_code,
            subdistrict_name: this.subdistrict_name,
            district_code: this.district_code,
            district_name: this.district_name,
            province_code: this.province_code,
            province_name: this.province_name,
            zipcode: this.zipcode,
            countryId: this.countryId,
        };

        return Util.cleanObjectEmptyStr(params);
    };
}
